import {z} from 'zod';
import {isReleasedNewRegisterFlow} from '../../../config/unReleasePage';
import {emailRegex} from '../../../shared/services/emailValidation';
import {FREE_MAIL_DOMAIN_LIST} from './constants';

export const PostInquiryGeneralSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z.string().regex(emailRegex, 'メールアドレスの形式で入力してください'),
  name: z.string().min(1, {message: '必須項目です'}),
  subject: z.string().min(2, {message: '必須項目です'}),
});

export const PostInquiryRegisterSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z.string().regex(emailRegex, 'メールアドレスの形式で入力してください'),
  name: z.string().min(1, {message: '必須項目です'}),
  univ_email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください'),
  univ_name: z.string().min(1, {message: '必須項目です'}),
});

export const PostInquiryTarekomiSchema = z.object({
  body: z.string().min(5, {message: '必須項目です'}),
  email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください')
    .or(z.string().length(0)),
  name: z.string().min(0),
});

export const InquiryForeignUnivSchema = z.object({
  email: z
    .string()
    .regex(emailRegex, 'メールアドレスの形式で入力してください')
    .max(100, {message: '100文字以内で入力してください'}) // DB依存
    .refine(
      (value) => !FREE_MAIL_DOMAIN_LIST.includes(value.split('@')[1] ?? ''),
      'フリーアドレスは受け付けできません',
    ),
  program: z.string().min(1, {message: '必須項目です'}),
  degree: z.string().min(1, {message: '必須項目です'}),
  univ_name: z.string().min(1, {message: '必須項目です'}),
  url: z
    .string()
    .url({message: 'URLの形式で入力してください'})
    .min(1, {message: '必須項目です'}),
  country_name: z.string().min(1, {message: '必須項目です'}),
});

// 旧フローでは氏名をフォーム入力で受け取る。新フローでは認証済みユーザー情報から取得するため送らない
const inquiryForeignUnivNameShape = {
  name: z.string().min(1, {message: '必須項目です'}),
};

const validateForeignUnivDegreeOther = (schema: {
  degree: string;
  degree_other: string;
}): boolean =>
  schema.degree !== 'その他' ||
  (schema.degree === 'その他' && schema.degree_other.length > 0);

const foreignUnivDegreeOtherError = {
  message: '「その他」を選択している場合は、必須項目です',
  path: ['degree_other'],
};

export const InquiryForeignUnivFormSchema = isReleasedNewRegisterFlow()
  ? InquiryForeignUnivSchema.extend({degree_other: z.string()}).refine(
      validateForeignUnivDegreeOther,
      foreignUnivDegreeOtherError,
    )
  : InquiryForeignUnivSchema.extend({
      ...inquiryForeignUnivNameShape,
      degree_other: z.string(),
    }).refine(validateForeignUnivDegreeOther, foreignUnivDegreeOtherError);

// 送信データの型定義用。氏名は旧フローのみ送るため任意とする（送信可否はフォーム側で制御）
export const PostInquiryForeignUnivSchema = InquiryForeignUnivSchema.extend({
  name: z.string().optional(),
  user_introduce_campaign_id: z.string().optional().nullable(),
  introducer_id: z.string().optional().nullable(),
});
